export const TRADE_TRANSACTION_TYPES = ['Acquisition', 'Sell'] as const;
export type TradeTransactionType = (typeof TRADE_TRANSACTION_TYPES)[number];

export const ACQUISITION_PACKAGE_STATUSES = [
  'Bid',
  'Won',
  'Pending Settle',
  'Funded',
  'Lost',
  'Passed',
  'Indication'
] as const;
export type PackageStatus = (typeof ACQUISITION_PACKAGE_STATUSES)[number];

export const DEAL_PACKAGE_STATUSES = [
  'Sourced',
  'Awarded',
  'Pending Settle',
  'Settled (Sold)',
  'Hold',
  'Cancelled'
] as const;
export type DealPackageStatus = (typeof DEAL_PACKAGE_STATUSES)[number];

export type FormatType = 'Decimal' | 'Currency' | 'Rate' | 'Date' | 'Number' | 'Text';
export type ReviewOrderStatus = 'New Order' | 'Order Submitted' | 'Pending Legal' | 'In Progress' | 'Received' | 'Cancelled';
export type ExitDealPackageStatus = 'Sourced' | 'Awarded' | 'PendingSettle' | 'Hold' | 'Settled' | 'Cancelled';

/// Survivorship details
export type SurviveCode = '' | 'Seller' | 'DueDil' | 'Servicer' | 'Clarity' | 'Internal';
export type SurviveName = 'Golden' | 'Diligence' | 'Seller' | 'Servicer' | 'Clarity' | 'Internal';
export type SurviveAjaxName = 'golden' | 'diligence' | 'seller' | 'servicer' | 'clarity' | 'internal';
export type SurviveOption = 'retain' | 'highest' | 'highestNonNull';
export type SurviveCodeWithoutGolden = Exclude<SurviveCode, ''>;
export type SurviveCodeWithGolden = 'Golden' | SurviveCodeWithoutGolden;
export type SurviveFullOption = SurviveOption | SurviveCodeWithoutGolden;

export function convertSurvive(code: SurviveCode): SurviveName;
export function convertSurvive(code: SurviveName): SurviveCode;
export function convertSurvive(code: SurviveCode | SurviveName): SurviveCode | SurviveName {
  const mapping = {
    'retain': 'retain',
    'highest': 'highest',
    'highestNonNull': 'highestNonNull',
    '': 'Golden',
    'Golden': '',
    'DueDil': 'Diligence',
    'Diligence': 'DueDil',
    'Seller': 'Seller',
    'Servicer': 'Servicer',
    'Clarity': 'Clarity',
    'Internal': 'Internal'
  };
  return mapping[code] as SurviveCode | SurviveName;
}

export function convertSurviveToAjax(code: SurviveName): SurviveAjaxName {
  return (code[0].toLowerCase() + code.substr(1)) as SurviveAjaxName;
}